import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text, BoldText, ButtonText } from '../../common/Text';
import SpecialistSelectCard from '../SpecialistSelectCard';
import CardContainer from '../../common/CardContainer';
import { PrimaryButton } from '../../common/Buttons';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  background: #f7f7f7;
  padding: 0.625rem;
  margin: 0.5rem 0;
`;

const Title = styled(Text)`
  font-size: ${() => `${1 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
  opacity: 0.5;
  margin-left: 0.625rem;
`;

const BodyContainer = styled.div`
  display: flex;
  align-items: stretch;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const StyledSpecialistCard = styled(SpecialistSelectCard)`
  margin: 0.625rem 0.3125rem;
  width: 85%;
  flex-shrink: 0;
`;

const FooterContainer = styled(CardContainer)`
  flex-direction: column;
  align-items: stretch;
  padding: 0.5rem;
`;

const FooterTitle = styled(Text)`
  text-align: center;
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const FooterBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.625rem;
  margin-bottom: 0.5rem;
`;

const FooterIconContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-right: 0.5rem;
`;

const FooterIcon = styled.img`
  width: 1.875rem;
  height: 1.875rem;
  border-radius: 2rem;
`;

const FooterTranslatedIcon = styled(FooterIcon)`
  transform: ${(props) => `translateX(${0.6 * props.translate}rem)`};
`;

const FooterBodyText = styled(BoldText)`
  font-size: ${() => `${0.875 * process.env.REACT_APP_FONT_MULTIPLIER}rem`};
`;

const SpecialistSuggestMessage = ({
  onSpecialistCardTapped,
  onBookTapped,
  onShowOpdTapped,
  onSeeSpecialistsTapped,
  className,
  titleText,
  specialists,
  consultType,
  footerTitle,
  footerIcons,
  footerText,
  opdLabel,
  bookingLabel,
  sponsor,
  sponsorLogo,
}) => {
  const renderSpecialist = (ele) => {
    return (
      <StyledSpecialistCard
        key={ele.doctorId}
        onTap={() =>
          ele.profile &&
          onSpecialistCardTapped(
            ele.doctorId,
            consultType,
            bookingLabel,
            opdLabel
          )
        }
        onBookingTap={() => onBookTapped(ele, consultType)}
        onOpdTap={onShowOpdTapped}
        doctorPicture={ele.profileImg}
        doctorName={ele.doctorName}
        doctorQualifications={ele.vertical}
        doctorExperience={ele.experience}
        doctorPrice={ele.finalFee.toString()}
        doctorOrganizationImage={ele.orgImg}
        doctorOrganizationText={ele.orgName}
        doctorLocation={ele.distance}
        feeLabel={ele.feeLabel}
        opdLabel={opdLabel}
        bookingLabel={bookingLabel}
        sponsor={ele.sponsor}
        sponsorLogo={ele.sponsorLogo}
      />
    );
  };
  return (
    <OuterContainer className={className}>
      <Title>{titleText}</Title>
      <BodyContainer>{specialists.map(renderSpecialist)}</BodyContainer>
      <FooterContainer>
        <FooterTitle>{footerTitle}</FooterTitle>
        <FooterBody>
          {footerIcons.length > 0 && (
            <FooterIconContainer>
              <FooterIcon src={footerIcons[0]} />
              {footerIcons.slice(1).map((ele, idx) => (
                <FooterTranslatedIcon key={idx} translate={idx + 1} src={ele} />
              ))}
            </FooterIconContainer>
          )}
          <FooterBodyText>{footerText}</FooterBodyText>
        </FooterBody>
        <PrimaryButton onTap={onSeeSpecialistsTapped}>
          <ButtonText>See All Specialists</ButtonText>
        </PrimaryButton>
      </FooterContainer>
    </OuterContainer>
  );
};

SpecialistSuggestMessage.propTypes = {
  onSpecialistCardTapped: PropTypes.func,
  onBookTapped: PropTypes.func,
  onShowOpdTapped: PropTypes.func,
  onSeeSpecialistsTapped: PropTypes.func,
  titleText: PropTypes.string,
  specialists: PropTypes.array,
  consultType: PropTypes.string,
  footerIcons: PropTypes.arrayOf(PropTypes.string),
  footerTitle: PropTypes.string,
  footerText: PropTypes.string,
  opdLabel: PropTypes.string,
  bookingLabel: PropTypes.string,
};

SpecialistSuggestMessage.defaultProps = {
  footerIcons: [],
};

export default SpecialistSuggestMessage;
